import React from "react";
import { Box, Typography } from "@mui/material";
import { ValueChicklet } from "./ValueChicklet";
import CancelIcon from "@mui/icons-material/Cancel";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import SearchInput from "./SearchInput";

export function SearchItems({
  itemInputRef,
  index,
  searchKey,
  operator,
  searchVal,
  onItemRemoved,
  onItemEdited,
  mode,
  activeItemIndex,
  querySearch,
  searchInputProps,
  onEditCancel,
}) {
  const isComplete =
    (searchVal && operator.value && index !== activeItemIndex) ||
    !querySearch;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "nowrap",
        flexShrink: 0,
        gap: 0.75,
        padding: "4px 8px",
        border: 1,
        borderColor: isComplete ? "divider" : "error.main",
        borderRadius: "18px",
      }}
    >
      <Typography variant="body2" component="span" sx={{ whiteSpace: "nowrap" }}>
        {searchKey}
      </Typography>

      {operator.value?.length > 0 && (
        <Typography
          variant="body2"
          component="span"
          sx={{ whiteSpace: "nowrap", opacity: 0.7 }}
        >
          {operator.value}
        </Typography>
      )}

      {activeItemIndex !== index && searchVal && (
        <ValueChicklet
          index={index}
          mode={mode}
          operator={operator}
          searchVal={searchVal}
          onItemEdited={onItemEdited}
        />
      )}

      {(!operator?.value || !searchVal || activeItemIndex === index) && (
        <SearchInput {...searchInputProps} inputRef={itemInputRef} />
      )}

      {mode !== "editValue" && (
        <CancelIcon
          color="primary"
          onClick={(event) => {
            event.stopPropagation();
            onItemRemoved(index);
          }}
          sx={{
            height: "18px",
            width: "18px",
            cursor: "pointer",
            ml: 0.5,
          }}
        />
      )}
      {mode === "editValue" && activeItemIndex === index && (
        <ModeEditIcon
          color="primary"
          onClick={(event) => {
            event.stopPropagation();
            onEditCancel();
          }}
          sx={{
            height: "18px",
            width: "18px",
            cursor: "pointer",
            ml: 0.5,
          }}
        />
      )}
    </Box>
  );
}
